import { useEffect } from 'react';
import useIsFirstRender from '../../../../../hooks/useIsFirstRender';
import { useApplicationContext } from '../../../../context/ApplicationContext/ApplicationContext';
import {
  restartOfflineQueryClientToNewTeam,
  unsubscribeFirstOfflineDataRestore,
} from '../../../queryClient/offlineQueryClient';
import { useOfflineDownloadStatusStore } from '../stores/offlineDownloadStatus/offlineDownloadStatus.store';

export const useHandleHydrateStores = () => {
  const { team } = useApplicationContext();
  const isFirstRender = useIsFirstRender();

  useEffect(() => {
    useOfflineDownloadStatusStore.persist.rehydrate();

    if (isFirstRender) {
      () => unsubscribeFirstOfflineDataRestore();
      return;
    }

    const unsubscribeQueries = restartOfflineQueryClientToNewTeam();

    return () => {
      unsubscribeQueries();
    };
  }, [team?.id]);
};
